import { createContentHook } from './createContentHook';
import type { SalesAndResourcesSensorAcademyContent } from '../types/SalesAndResourcesSensorAcademyContent';

export const useSalesAndResourcesSensorAcademyContent =
    createContentHook<SalesAndResourcesSensorAcademyContent>('/SalesAndResources/SensorAcademy');
